import { forwardRef } from 'react';

import Video from 'react-scale/components/elements/video';
import Modal from 'react-scale/components/tailwind/Modal';

const VideoModal = forwardRef(({ isShowing, close, time, url }, ref) => (
  <Modal
    isShowing={isShowing}
    hide={close}
    borderColor={false}
    contentClassName="w-[95vw] md:w-[80vw] lg:w-[70vw] backdrop-blur-xl bg-white rounded-2xl bg-opacity-[15%]"
    hideCloseButton
  >
    <Video
      onReady={() => ref.current.seekTo(time, 'seconds')}
      ref={ref}
      controls
      url={url}
      playing
    />
  </Modal>
));

export default VideoModal;
